import HelperMixin from '../../../Shared/HelperMixin.vue'
export default {
    name: 'AppFooter',  
    mixins: [HelperMixin],
    async created() { 
        await this.CheckLoginStatus();
    },
    data() {
        return {            
        };
    },
  
    methods: {
      
    }    
}
